import { render } from "./PlayerWrap.vue?vue&type=template&id=e4af489c&scoped=true"
import script from "./PlayerWrap.vue?vue&type=script&lang=js"
export * from "./PlayerWrap.vue?vue&type=script&lang=js"

import "./PlayerWrap.vue?vue&type=style&index=0&id=e4af489c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4af489c"]])

export default __exports__